module.exports = __webpack_public_path__ + "static/media/header_myfavotitef60836aadaabff183b2658d315418483.webp";